import { ActiveSessionsScreen } from "@/features/menu/settings/ActiveSessionsScreen";

export default function ActiveSessions() {
    return <ActiveSessionsScreen />;
}
